// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const syncAccountPathParamsSchema = z.object({
  account_id: z.number().int().describe("Timely Account Id"),
});

export const syncAccountHeaderParamsSchema = z.object({
  Authorization: z.optional(z.coerce.string()),
});

/**
 * @description Account sync job queued
 */
export const syncAccount200Schema = z.unknown();

/**
 * @description Unauthorized
 */
export const syncAccount401Schema = z.object({
  errors: z.optional(z.object({
    message: z.optional(z.coerce.string()),
  })),
});

/**
 * @description Forbidden
 */
export const syncAccount403Schema = z.object({
  errors: z.optional(z.object({
    message: z.optional(z.coerce.string()),
  })),
});

/**
 * @description Not Found
 */
export const syncAccount404Schema = z.object({
  errors: z.optional(z.object({
    message: z.optional(z.coerce.string()),
  })),
});

/**
 * @description Internal Server Error
 */
export const syncAccount500Schema = z.object({
  errors: z.optional(z.object({
    message: z.optional(z.coerce.string()),
  })),
});

export const syncAccountMutationResponseSchema = z.lazy(() => syncAccount200Schema);
